export default "__VITE_ASSET__dfb2d841__"